import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollAnimation();
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: iconsRef, visibleItems } = useStaggerAnimation(4, { threshold: 0.1 });

  return (
    <section
      id="about"
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="py-32 bg-[#F8F6F3]"
    >
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left column */}
          <div
            ref={leftRef as React.RefObject<HTMLDivElement>}
            style={{
              opacity: leftVisible ? 1 : 0,
              transform: leftVisible ? 'translateX(0)' : 'translateX(-48px)',
              transition: 'opacity 0.8s ease, transform 0.8s ease',
            }}
          >
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 bg-[#1A2B4A] rotate-45"></div>
              <span className="text-sm font-medium text-gray-600 uppercase tracking-wide">Nuestra historia</span>
            </div>

            <h2 className="text-5xl font-bold text-[#1A2B4A] leading-tight mb-12">
              Fundada desde<br />
              la experiencia real
            </h2>

            <div className="relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_0ed2324f5dc14abd84d5f43d0842588f_f3dffbad.jpg"
                alt="Fundadoras de BN ĀGENZIA"
                className="w-full h-auto object-cover object-top"
                style={{
                  transform: leftVisible ? 'scale(1)' : 'scale(1.06)',
                  transition: 'transform 1.2s ease',
                }}
              />
            </div>
          </div>

          {/* Right column */}
          <div
            ref={rightRef as React.RefObject<HTMLDivElement>}
            style={{
              opacity: rightVisible ? 1 : 0,
              transform: rightVisible ? 'translateX(0)' : 'translateX(48px)',
              transition: 'opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s',
            }}
            className="space-y-8"
          >
            <p className="text-lg text-gray-700 leading-relaxed">
              BN ĀGENZIA nace de nuestra experiencia directa. Somos dos hermanas que trabajamos en diferentes países europeos y vivimos en primera persona los desafíos de los procesos de colocación internacional: la falta de transparencia, el trato impersonal y la desconexión entre lo prometido y la realidad.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              Esa vivencia nos motivó a crear una agencia diferente. Una firma en la que no trabajamos por volumen, sino por encaje real. No enviamos perfiles al azar: diseñamos conexiones estratégicas y sostenibles entre empresas europeas y profesionales cualificados.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              A diferencia de las agencias tradicionales, operamos como una boutique especializada: procesos personalizados, confidencialidad garantizada y acompañamiento real en cada etapa. No gestionamos masas, construimos relaciones.
            </p>

            <div
              ref={iconsRef as React.RefObject<HTMLDivElement>}
              className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12 pt-12 border-t border-gray-300"
            >
              {[
                { icon: 'ri-shield-check-line', title: 'Experiencia real', desc: 'Hemos vivido el proceso desde dentro' },
                { icon: 'ri-eye-line', title: 'Transparencia', desc: 'Somos claras en cada etapa del proceso' },
                { icon: 'ri-hand-heart-line', title: 'Acompañamiento', desc: 'Te acompañamos hasta lograr el encaje perfecto' },
                { icon: 'ri-star-line', title: 'Selección cuidada', desc: 'Priorizamos la calidad sobre la cantidad' },
              ].map((item, i) => (
                <div
                  key={item.title}
                  className="flex items-start gap-4"
                  style={{
                    opacity: visibleItems[i] ? 1 : 0,
                    transform: visibleItems[i] ? 'translateY(0)' : 'translateY(24px)',
                    transition: `opacity 0.5s ease, transform 0.5s ease`,
                  }}
                >
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-[#1A2B4A]`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
